import { Swiper } from '@components/swiper'
import { Classification } from '@global/api/types'
import { Actions } from './actions'
import { NoSourceURL } from './no-source-url'
import { ToggleAi } from './toggle-ai'
import * as css from '../styles'

export interface DropdownContentProps {
  classifications?: Classification[]
  toggleClassification: (id: number) => void
  hasSourceUrl: boolean
  selected: Record<number, boolean>
  innerRef?: React.RefObject<HTMLDivElement>
  isCreativeClassificationEnabled: boolean
}

export const DropdownContent = ({
  classifications,
  toggleClassification,
  selected,
  isCreativeClassificationEnabled,
  hasSourceUrl,
  innerRef,
}: DropdownContentProps) => {
  if (!classifications) return null

  const isAnyClassificationEnabled = classifications?.some(
    classification => selected[classification.id],
  )

  return (
    <css.ContentContainer
      initial="collapsed"
      animate="expanded"
      exit="collapsed"
      variants={{
        expanded: { height: 'auto', opacity: 1 },
        collapsed: { height: 0, opacity: 0 },
      }}
      transition={{
        duration: 0.2,
        ease: [0.5, 0, 0.5, 1],
      }}
    >
      {!isCreativeClassificationEnabled || (!isAnyClassificationEnabled && !hasSourceUrl) ? (
        <div style={{ overflow: 'hidden' }}>
          <Swiper
            defaultActiveIndex={isCreativeClassificationEnabled ? 1 : 0}
            slideWidth={innerRef?.current?.getBoundingClientRect().width || 268}
          >
            <ToggleAi isEnabled={isCreativeClassificationEnabled} />
            <NoSourceURL />
          </Swiper>
        </div>
      ) : (
        <Actions
          classifications={classifications}
          toggleClassification={toggleClassification}
          selected={selected}
        />
      )}
    </css.ContentContainer>
  )
}
